import React, { PropTypes } from 'react';
import { Button } from 'semantic-ui-react';
import { compose, defaultProps } from 'recompose';

const propTypes = {
  to: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
};

const LinkedinLogin = ({ to, buttonLabel }) => (
  <Button
    as="a"
    href={to}
    fluid
    size="big"
    color="linkedin"
  >
    {buttonLabel}
  </Button>
);

LinkedinLogin.propTypes = propTypes;

const login = '#';
const enhance = compose(
  defaultProps({ login }),
);

export default enhance(LinkedinLogin);



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/components/linkedinLogin/LinkedinLogin.js
 **/